export default __webpack_public_path__ + "static/media/fail.fece35ca.m4a";